<template>
  <div class="input-number-wrap">
    <span v-if="label" class="label">{{label}}</span>
    <div class="input-number">
      <span @click="change(1)">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-jianliang" />
        </svg>
      </span>
      <span class="num">{{modelValue}}</span>
      <span @click="change(2)">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-jialiang" />
        </svg>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    max: {
      //最大值
      type: Number,
      default: Infinity,
    },
    min: {
      //最小值
      type: Number,
      default: -Infinity,
    },
    modelValue: {
      type: [Number, String],
      default: 0,
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      priceNum: 1,
    }
  },
  emits: ['update:modelValue', 'change'],
  methods: {
    //设置购买个数
    change(type) {
      if (this.disabled) return
      //i 1-- 2++
      if (type == 1) {
        // 点击减号
        if (Number(this.modelValue) - this.step < this.min) {
          this.$toaster({
            message: '当前数量最少为' + this.min,
            duration: 1000,
            show: true,
          })
        } else {
          this.$emit('update:modelValue', Number(this.modelValue) - this.step)
          this.$emit('change', Number(this.modelValue) - this.step)
        }
      } else {
        // 点击加号
        if (Number(this.modelValue) + this.step > this.max) {
          this.$toaster({
            message: '当前数量最大为' + this.max,
            duration: 1000,
            show: true,
          })
        } else {
          this.$emit('update:modelValue', Number(this.modelValue) + this.step)
          this.$emit('change', Number(this.modelValue) + this.step)
        }
      }
    },
  },
}
</script>
<style lang="less" scoped>
.input-number-wrap {
  max-width: 200px;
  font-size: 0;
  display: inline-block;
  overflow: hidden;
  line-height: 34px;
  .label {
    font-size: 26px;
    float: left;
    padding-right: 12px;
  }
  .input-number {
    float: left;
    display: flex;
    justify-content: space-between;
  }
  .num {
    font-size: 32px;
    color: #f50;
    margin: 0 10px;
    min-width: 60px;
  }
  .svg-icon {
    vertical-align: middle;
    width: 34px;
    height: 34px;
    margin-top: 0px;
  }
}
</style>
